module.exports = __webpack_public_path__ + "img/GALLERY-SCROSS-1.731aa6d1.jpg";